/**
 * @file Web Gallery Blog post card.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash.get';
import moment from 'moment';
import classNames from 'classnames';

import { getThumbBySize } from '../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../constants/image-size-codes';
import AlbumPhotoGroupIcon from '../../../components/icons/AlbumPhotoGroupIcon';
import Badge from '../../../components/global/Badge';
import { getWebGalleryBlogPostLinkData } from '../utilities/web-galleries';

const propTypes = {
  blogPost: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    excerpt: PropTypes.string,
    cover_photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
        }),
      ),
    }),
  }),
  linksTo: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const WebGalleryBlogPostCard = ({ blogPost, linksTo, className }) => {
  const classes = classNames({
    'blog-post-card': true,
    [className]: !!className,
  });

  const coverPhotoThumbnail = getThumbBySize(
    get(blogPost, 'cover_photo.thumbnail_urls'),
    IMAGE_SIZE_CODE.MEDIUM2X,
  );

  const [blogPostLink] = get(blogPost, 'blog_post_links.records', []);

  return (
    <div className={classes}>
      <Link to={`${linksTo}/${blogPost.id}`}>
        {coverPhotoThumbnail ? (
          <figure className="blog-post-card-thumb">
            <img src={coverPhotoThumbnail.url} alt="" />
          </figure>
        ) : (
          <figure className="blog-post-card-thumb">
            <div className="blog-post-card-thumb-empty">
              <AlbumPhotoGroupIcon color="#e9e9e9" />
            </div>
          </figure>
        )}

        <div className="blog-post-card-content">
          <h3 className="blog-post-card-title">
            {blogPost.title || '(Untitled)'}
          </h3>
          <div className="blog-post-card-meta">
            <time className="blog-post-card-time">
              {moment(blogPost.created_at).format('DD MMM, YYYY')}
            </time>
          </div>
          {blogPostLink && (
            <div>
              <Badge badgeStyle="yellow" badgeSize="xs">
                {getWebGalleryBlogPostLinkData(blogPostLink).name}
              </Badge>
            </div>
          )}
          {blogPost.excerpt && (
            <div className="blog-post-card-excerpt">
              <p>{blogPost.excerpt}&hellip;</p>
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

WebGalleryBlogPostCard.propTypes = propTypes;

export default WebGalleryBlogPostCard;
